<template>
  <div id="app">
    <div style="padding-bottom: 100px;">
      <Header
        name=""
        :navLinks="[
          {
            name: 'Home',
            link: '/'
          },
          { name: 'Search Video in Channel', link: '/Search' },
          { name: 'PlayList', link: '/PlayList' }
        ]"
      />
    </div>

    <router-view />
  </div>
</template>

<script>
import Header from "./components/layout/Header";

export default {
  name: "app",
  components: {
    Header
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* https://codepen.io/mutedblues/pen/MmPNPG?editors=1100 */
body {
  margin: 0;
  font-family: Helvetica, sans-serif;
  background-color: #f4f4f4;
}
</style>
